<div class="button-toolbar">
  <div style="display: flex; justify-content: space-between; align-items:flex-start;">
    <div style="align-items:flex-start">

      <div class="btn-group" role="group">
        <span class="d-inline-block" data-bs-toggle="tooltip" title="Reset">
          <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Reset
          </button>

          <ul class="dropdown-menu">
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Reload the application from the server">
                <a class="dropdown-item" (click)="onButtonAction('resetApplication','')">Application</a>
              </span>
            </li>
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Reset the section currently selected">
                <a class="dropdown-item" (click)="onButtonAction('resetSection','')">Section</a>
              </span>
            </li>

          </ul>
        </span>
      </div>

      <button type="button" class="btn btn-light" *ngIf="showRemoveButton();"
        aria-label="Remove the results items from the list" title="Remove the results items from the list"
        (click)="onButtonAction('remove',selectedNode)">Remove</button>

      <button type="button" class="btn btn-light" *ngIf="showRemoveItemsMedicinalProductNodeButton();"
        aria-label="Remove all selected elements in the list" title="Remove selected item(s) from the Tree View Area"
        (click)="onButtonAction('removeall', selectedNode)">Remove</button>

      <div class="btn-group" role="group" *ngIf="(showXMLButton() || showRTFButton() || isAutoUploadNode() || isAbstractCompositionQuery() || this.isAbstractCompositionNode()) && (!this.hideButton())">
        <span class="d-inline-block" data-bs-toggle="tooltip" title="Export message">
          <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Export
          </button>
          <ul class="dropdown-menu">
            <li *ngIf="showXMLButton() || isAutoUploadNode()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                [aria-label]="'Export the selected ' + this.getParentNodeLabel()+ ' as XML'"
                [title]="'Export the selected ' + this.getParentNodeLabel()+ ' as XML'">
                <a class="dropdown-item" (click)="onButtonAction('exportSingleXML',selectedNode)">XML</a>
              </span>
            </li>
            <li *ngIf="showRTFButton() || isAutoUploadNode() || isAbstractCompositionQuery() ||this.isAbstractCompositionNode()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                [aria-label]="'Export all the ' + this.getParentNodeLabel()+ ' as RTF document (Rich Text Format)'"
                [title]="'Export all the ' + this.getParentNodeLabel()+ ' as RTF document (Rich Text Format)'">
                <a class="dropdown-item" (click)="onButtonAction('exportSingleRTF',selectedNode)">RTF</a>
              </span>
            </li>
            <li *ngIf="showRTFButton()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                [aria-label]="'Export all the ' + this.getParentNodeLabel()+ ' as RTF document (Rich Text Format)'"
                [title]="'Export all the ' + this.getParentNodeLabel()+ ' as RTF document (Rich Text Format)'">
                <a class="dropdown-item" (click)="onButtonAction('exportMultiRTF',selectedNode)">Multi RTF</a>
              </span>
            </li>
            <li *ngIf="showXMLButton()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                [aria-label]="'Export the selected ' + this.getParentNodeLabel()+ ' as XML'"
                [title]="'Export the selected ' + this.getParentNodeLabel()+ ' as XML'">
                <a class="dropdown-item" (click)="onButtonAction('exportMultiXML',selectedNode)">Multi XML</a>
              </span>
            </li>
          </ul>
        </span>
      </div>

      <button type="button" class="btn btn-light" *ngIf="showRunButton();" aria-label="Run query" title="Run query"
        (click)="onButtonAction('runQuery', selectedNode)">Run</button>

      <button type="button" class="btn btn-light" *ngIf="showRefreshButton()" title="Refresh"
        (click)="onButtonAction('refreshMedicinalProducts', selectedNode)">Refresh</button>

      <button type="button" class="btn btn-light" *ngIf="isResultNode() && (!this.isAbstractCompositionNode())" aria-label="Re-Run Query"
        title="Use this functionality to launch the existing query again"
        (click)="onButtonAction('reRunQuery', selectedNode)">ReRun</button>

      <button type="button" class="btn btn-light" *ngIf="showModify();" aria-label="Modify Query Criteria"
        title="Use this functionality to modify the criteria of your previous query"
        (click)="onButtonAction('moveToModifyNode', selectedNode)">Modify</button>

      <button type="button" class="btn btn-light" *ngIf="showRunToExcel();" aria-label="To export the results of the query in an excel file"
        title="To export the results of the query in an excel file" (click)="onButtonAction('runToExcel', selectedNode)">Run to
        Excel</button>


      <div class="btn-group" role="group" *ngIf="showOperations() && !this.isSubstanceNamesNode() && (!this.isXevprmMessageSimpleSearch())">
        <span class="d-inline-block" data-bs-toggle="tooltip" title="Reset">
          <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
            title="Operations">
            Operations
          </button>

          <ul class="dropdown-menu">
            <li *ngIf="showReinsert()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Reinsert the currently selected item">
                <a class="dropdown-item"
                  (click)="onButtonAction('operate',{node:selectedNode,operation:1})">Reinsert</a>
              </span>
            </li>
            <li *ngIf="showInvalidateMA()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Invalidate MA for the currently selected item">
                <a class="dropdown-item" 
                  (click)="onButtonAction('operate', {node:selectedNode,operation:6})">Invalidate MA</a>
              </span>
            </li>
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Update the currently selected item">
                <a class="dropdown-item" 
                  (click)="onButtonAction('operate', {node:selectedNode,operation:2})">Update</a>
              </span>
            </li>
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Nullify the currently selected item">
                <a class="dropdown-item" 
                  (click)="onButtonAction('operate',{node:selectedNode,operation:4})">Nullify</a>
              </span>
            </li>
            <li *ngIf="showAssessment()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Assess as Valid">
                <a class="dropdown-item"
                  (click)="onButtonAction('assess',{node:selectedNode, type:'val'})">Assess as Valid</a>
              </span>
            </li>
            <li *ngIf="showProductAssessment()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Clear Valid">
                <a class="dropdown-item" 
                  (click)="onButtonAction('assess', {node:selectedNode, type: 'clearVal'})">Clear Valid</a>
              </span>
            </li>
          </ul>
        </span>
      </div>

      <div class="btn-group" role="group"  *ngIf="showCompare() && (!this.isXevprmMessageSimpleSearch())">
        <span class="d-inline-block" data-bs-toggle="tooltip" title="Reset">
          <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
            title="Compare">
            Compare
          </button>

          <ul class="dropdown-menu">
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Compare the loaded version to the first version">
                <a class="dropdown-item" 
                  (click)="onButtonAction('compare',{ node: selectedNode, type: 'FIRST' })">To first version</a>
              </span>
            </li>
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Compare the loaded version to the last version">
                <a class="dropdown-item" 
                  (click)="onButtonAction('compare',{ node: selectedNode, type: 'LAST' })">To last version</a>
              </span>
            </li>
             <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Compare the loaded version to the next version">
                <a class="dropdown-item" 
                  (click)="onButtonAction('compare',{ node: selectedNode, type: 'NEXT' })">To next version</a>
              </span>
            </li>
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Compare the loaded version to the last pending version">
                <a class="dropdown-item" 
                  (click)="onButtonAction('compare',{ node: selectedNode, type: 'PENDING' })">To pending version</a>
              </span>
            </li>
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Compare the loaded version to the previous version">
                <a class="dropdown-item" 
                  (click)="onButtonAction('compare',{ node: selectedNode, type: 'PREVIOUS' })">To previous version</a>
              </span>
            </li>
            <li *ngIf="showCompareRejected()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Compare the loaded version to the last rejected version">
                <a class="dropdown-item" 
                  (click)="onButtonAction('compare',{ node: selectedNode, type: 'REJECTED' })">To rejected version</a>
              </span>
            </li>
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Compare the loaded version to the last valid version">
                <a class="dropdown-item" 
                  (click)="onButtonAction('compare',{ node: selectedNode, type: 'VALID' })">To valid version</a>
              </span>
            </li>
          </ul>
        </span>
      </div>
        <div class="d-inline-block" title="Deselect All">
        <button type="button" class="btn btn-light" *ngIf="showDeselectAllButton()" aria-label="Deselect All"
          (click)="onButtonAction('deselectAll', selectedNode)"
          [disabled]="!isEnabledDeselectAll(selectedNode)">&#x2610;</button>
      </div>

      <div class="d-inline-block" title="Select All">
        <button type="button" class="btn btn-light" *ngIf="showSelectAllButton()" aria-label="Select All"
          (click)="onButtonAction('selectAll', selectedNode)"
          [disabled]="!isEnabledSelectAll(selectedNode)">&#x2611;</button>
      </div>

      <div class="btn-group" role="group" *ngIf="showExport();">
        <span class="d-inline-block" data-bs-toggle="tooltip" title="Export">
          <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Export
          </button>

          <ul class="dropdown-menu">
            <li *ngIf="showSectionExport() && !this.isSubstanceNamesNode() && !this.isAbstractCompositionQuery()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Export selected items to multiple XML Files (one file for each selected item)">
                <a class="dropdown-item" (click)="onButtonAction('exportMultiXML',selectedNode)">Multi XML Files</a>
              </span>
            </li>
            <li *ngIf="showSectionExport() && !this.isSubstanceNamesNode() && !this.isAbstractCompositionQuery()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Export selected items to one XML File ">
                <a class="dropdown-item" (click)="onButtonAction('exportSingleXML',selectedNode)">One XML File</a>
              </span>
            </li>
            <li *ngIf="showSectionExport() && !this.isSubstanceNamesNode() && !this.isAbstractCompositionQuery()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Export selected items to multiple RTF Files (one file for each selected item)">
                <a class="dropdown-item" (click)="onButtonAction('exportMultiRTF',selectedNode)">Multi RTF Files</a>
              </span>
            </li>
            <li *ngIf="showSectionExport() && !this.isSubstanceNamesNode() && !this.isAbstractCompositionQuery()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Export selected items to one RTF File ">
                <a class="dropdown-item" (click)="onButtonAction('exportSingleRTF',selectedNode)">One RTF File</a>
              </span>
            </li>
            <li *ngIf="isResultNode() && !this.isAbstractCompositionNode() && !this.isAbstractCompositionQuery()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Export all displayed items to one Excel file">
                <a class="dropdown-item" (click)="onButtonAction('exportToExcel',selectedNode)">One Excel File</a>
              </span>
            </li>
          </ul>
        </span>
      </div>

      <button type="button" class="btn btn-light" *ngIf="showLoadAllButton()" aria-label="Load"
        title="Load the selected item(s) in the tree view area"
        (click)="onButtonAction('loadSelected', selectedNode)">Load</button>
      <button type="button" class="btn btn-light" *ngIf="showLoadDinamicEntityButton()" aria-label="Load"
        title="Load the current entity in the tree view area"
        (click)="onButtonAction('loadDynamicEntity', selectedNode)">Load</button>

      <button type="button" class="btn btn-light" [title]="'Sort ' + (isConditionsNode() ? 'conditions' : 'fields') + ' alphabetically'" *ngIf="showSortButton()"
      (click)="onButtonAction('sortField', selectedNode, sortOrder)">
        <span *ngIf="sortOrder" class="bi bi-sort-alpha-down"></span>
        <span *ngIf="!sortOrder" class="bi bi-sort-alpha-up"></span>
      </button>
    </div>
       
    <div style="align-items:flex-end" *ngIf="isPaginationAllowed()">
      <div class="btn-group" role="group">
        <span class="d-inline-block" data-bs-toggle="tooltip" title="Page size: {{selectedNode.selectedPageSize}}">
          <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" [disabled]="this.isLoading()">
            {{ selectedNode.selectedPageSize }}
          </button>
          <ul class="dropdown-menu">
            <li *ngFor="let item of this.pageSizes">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip" title="Page Size: {{item.value}}">
                <a class="dropdown-item" (click)="onPageSizeSelected(item, $event)">{{item.value}}</a>
              </span>
            </li>
          </ul>
        </span>
      </div>
      <button type="button" class="btn btn-light" aria-label="Add next page of results" title="Add next page of results"
        (click)="onButtonAction('addPage',selectedNode)" [disabled]="this.isLoading()"><i class="pi pi-plus"></i></button>
      <button type="button" class="btn btn-light" aria-label="Back to top" title="Back to top"
        (click)="onButtonAction('topPage',selectedNode)" [disabled]="this.isLoading()"><i class="pi pi-arrow-up"></i></button>
      <button type="button" class="btn btn-light" aria-label="Get previous Page" title="Get previous Page"
        (click)="onButtonAction('previousPage',selectedNode)" [disabled]="this.isLoading()"><i class="pi pi-arrow-left"></i></button>
      <button type="button" class="btn btn-light" aria-label="Get next Page" title="Get next Page"
        (click)="onButtonAction('nextPage',selectedNode)" [disabled]="this.isLoading()"><i class="pi pi-arrow-right"></i></button>
    </div>
  </div>
</div>